import s from './FloatingLabel.module.css';
import { FloatingLabelProps } from '@/types/model';
import { AnimatePresence, motion } from 'framer-motion';
import { ErrorVariants } from '@/lib/variants';

const FloatingLabel = ({
  inputName,
  placeholder,
  type,
  hasError,
  errorMessage,
  handleChange,
  handleBlur,
  value,
  autoComplete
}: FloatingLabelProps) => {
  return (
    <div className={s.container}>
      <input
        className={s.container__input}
        autoComplete={autoComplete || 'off'}
        name={inputName}
        id={inputName}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        type={type}
        aria-label={placeholder || inputName}
      />
      <AnimatePresence initial={false}>
        {hasError && errorMessage && (
          <motion.span
            className={s.container__error_message}
            variants={ErrorVariants}
            initial="hide"
            animate="visible"
            exit="exit">
            {errorMessage}
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingLabel;
